import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	// UI state: per-LV expanded group IDs in service specifications view.
	// Key: lvId, Value: array of expanded group IDs (array, not Set, for
	// Redux serializability).
	expandedGroups: {},
};

const projectLVSlice = createSlice({
	name: "projectLV",
	initialState,
	reducers: {
		toggleExpandedGroup: (state, action) => {
			const { lvId, groupId } = action.payload;
			if (!state.expandedGroups[lvId]) {
				state.expandedGroups[lvId] = [];
			}
			const index = state.expandedGroups[lvId].indexOf(groupId);
			if (index > -1) {
				state.expandedGroups[lvId].splice(index, 1);
			} else {
				state.expandedGroups[lvId].push(groupId);
			}
		},
		setExpandedGroups: (state, action) => {
			const { lvId, groupIds } = action.payload;
			state.expandedGroups[lvId] = groupIds;
		},
		clearExpandedGroups: (state, action) => {
			const { lvId } = action.payload;
			state.expandedGroups[lvId] = [];
		},
	},
});

export const {
	toggleExpandedGroup,
	setExpandedGroups,
	clearExpandedGroups,
} = projectLVSlice.actions;

export const selectExpandedGroupsForLV = (lvId) => (state) => {
	const expandedArray = state.projectLV.expandedGroups[lvId] || [];
	return new Set(expandedArray);
};

export default projectLVSlice.reducer;
